import {
  HISTORY_LOG_VARIANT,
  HISTORY_LOG_DATA,
  HISTORY_LOG_COUNT,
  HISTORY_LOG_TOGGLE_MODAL,
  HISTORY_LOG_OFFSET,
  HISTORY_LOG_PER_PAGE,
} from '../constants/historyLogTypes';

const initialState = {
  data: [],
  variant: {},
  open: false,
  offset: 0,
  count: 0,
  perPage: 10,
};

const historyLog = (state = initialState, action) => {
  switch (action.type) {
    case HISTORY_LOG_VARIANT:
      return {
        ...state,
        variant: action.payload,
      };

    case HISTORY_LOG_DATA:
      return {
        ...state,
        data: action.payload,
      };

    case HISTORY_LOG_OFFSET:
      return {
        ...state,
        offset: action.payload,
      };

    case HISTORY_LOG_PER_PAGE:
      return {
        ...state,
        perPage: +action.payload,
      };

    case HISTORY_LOG_COUNT:
      return {
        ...state,
        count: +action.payload,
      };

    case HISTORY_LOG_TOGGLE_MODAL:
      return {
        ...state,
        open: action.payload,
      };

    default:
      break;
  }

  return state;
};

export default historyLog;
